import gql from "graphql-tag";

const GET_WEBFORM_ATTACHMENT = gql`
  query getWebformAttachment($input: WebformAttachmentInformation) {
    getWebformAttachment(input: $input)
  }
`;
export default GET_WEBFORM_ATTACHMENT;
